import { render, staticRenderFns } from "./WechatPublic.vue?vue&type=template&id=35dcd75a&scoped=true&"
import script from "./WechatPublic.vue?vue&type=script&lang=js&"
export * from "./WechatPublic.vue?vue&type=script&lang=js&"
import style0 from "./WechatPublic.vue?vue&type=style&index=0&id=35dcd75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcd75a",
  null
  
)

export default component.exports